export const HOVER_SHADOW_OPTIONS: any = {
  none: 'hover:shadow-none',
  xs: 'hover:shadow-xs',
  sm: 'hover:shadow-sm',
  md: 'hover:shadow-md',
  lg: 'hover:shadow-lg',
  xl: 'hover:shadow-xl',
};
